import { AccredibleLanguage } from '@accredible-frontend-v2/models';
import localeAr from '@angular/common/locales/ar';
import localeCs from '@angular/common/locales/cs';
import localeDa from '@angular/common/locales/da';
import localeDe from '@angular/common/locales/de';
import localeEl from '@angular/common/locales/el';
import localeEn from '@angular/common/locales/en';
import localeEnGB from '@angular/common/locales/en-GB';
import localeEs from '@angular/common/locales/es';
import localeEs419 from '@angular/common/locales/es-419';
import localeFi from '@angular/common/locales/fi';
import localeFr from '@angular/common/locales/fr';
import localeHe from '@angular/common/locales/he';
import localeHi from '@angular/common/locales/hi';
import localeHr from '@angular/common/locales/hr';
import localeHu from '@angular/common/locales/hu';
import localeId from '@angular/common/locales/id';
import localeIt from '@angular/common/locales/it';
import localeJa from '@angular/common/locales/ja';
import localeKo from '@angular/common/locales/ko';
import localeMs from '@angular/common/locales/ms';
import localeNb from '@angular/common/locales/nb';
import localeNl from '@angular/common/locales/nl';
import localePl from '@angular/common/locales/pl';
import localePt from '@angular/common/locales/pt';
import localeRo from '@angular/common/locales/ro';
import localeRu from '@angular/common/locales/ru';
import localeSk from '@angular/common/locales/sk';
import localeSl from '@angular/common/locales/sl';
import localeSv from '@angular/common/locales/sv';
import localeTh from '@angular/common/locales/th';
import localeTr from '@angular/common/locales/tr';
import localeVi from '@angular/common/locales/vi';
import localeZh from '@angular/common/locales/zh';

export const AVAILABLE_LANGUAGES: AccredibleLanguage[] = [
  {
    code: 'ar',
    name: 'عربى',
    displayNameEn: 'Arabic (General)',
    matLib: localeAr,
  },
  {
    code: 'cs',
    name: 'Česky',
    displayNameEn: 'Czech',
    matLib: localeCs,
  },
  {
    code: 'da',
    name: 'Dansk',
    displayNameEn: 'Danish',
    matLib: localeDa,
  },
  {
    code: 'de',
    name: 'Deutsch',
    displayNameEn: 'German',
    matLib: localeDe,
  },
  {
    code: 'el',
    name: 'Νέα Ελληνικά',
    displayNameEn: 'Greek',
    matLib: localeEl,
  },
  {
    code: 'en',
    name: 'English (US)',
    displayNameEn: 'English (US)',
    matLib: localeEn,
  },
  {
    code: 'en-gb',
    name: 'English (UK)',
    displayNameEn: 'English (UK)',
    matLib: localeEnGB,
  },
  {
    code: 'es',
    name: 'Español',
    displayNameEn: 'Spanish',
    matLib: localeEs,
  },
  {
    code: 'es-419',
    name: 'Español (Latinoamérica)',
    displayNameEn: 'Spanish (Latin America)',
    matLib: localeEs419,
  },
  {
    code: 'fi',
    name: 'Suomi',
    displayNameEn: 'Finnish',
    matLib: localeFi,
  },
  {
    code: 'fr',
    name: 'Français',
    displayNameEn: 'French',
    matLib: localeFr,
  },
  {
    code: 'he',
    name: 'עברית',
    displayNameEn: 'Hebrew',
    matLib: localeHe,
  },
  {
    code: 'hi',
    name: 'हिन्दी',
    displayNameEn: 'Hindi',
    matLib: localeHi,
  },
  {
    code: 'hr',
    name: 'Hrvatski',
    displayNameEn: 'Croatian',
    matLib: localeHr,
  },
  {
    code: 'hu',
    name: 'Magyar',
    displayNameEn: 'Hungarian',
    matLib: localeHu,
  },
  {
    code: 'id',
    name: 'Bahasa Indonesia',
    displayNameEn: 'Indonesian',
    matLib: localeId,
  },
  {
    code: 'it',
    name: 'Italiano',
    displayNameEn: 'Italian',
    matLib: localeIt,
  },
  {
    code: 'ja',
    name: '日本語',
    displayNameEn: 'Japanese',
    matLib: localeJa,
  },
  {
    code: 'ko',
    name: '한국어',
    displayNameEn: 'Korean',
    matLib: localeKo,
  },
  {
    code: 'ms',
    name: 'Bahasa Melayu',
    displayNameEn: 'Malay',
    matLib: localeMs,
  },
  {
    code: 'nb',
    name: 'Norsk Bokmål',
    displayNameEn: 'Norwegian',
    matLib: localeNb,
  },
  {
    code: 'nl',
    name: 'Nederlands',
    displayNameEn: 'Dutch',
    matLib: localeNl,
  },
  {
    code: 'pl',
    name: 'Polski',
    displayNameEn: 'Polish',
    matLib: localePl,
  },
  {
    code: 'pt-br',
    name: 'Português (Brasil)',
    displayNameEn: 'Portuguese (Brazil)',
    matLib: localePt,
  },
  {
    code: 'pt-pt',
    name: 'Português (Portugal)',
    displayNameEn: 'Portuguese (Portugal)',
    matLib: localePt,
  },
  {
    code: 'ro',
    name: 'Română',
    displayNameEn: 'Romanian',
    matLib: localeRo,
  },
  {
    code: 'ru',
    name: 'Русский',
    displayNameEn: 'Russian',
    matLib: localeRu,
  },
  {
    code: 'sk',
    name: 'Slovenský',
    displayNameEn: 'Slovak',
    matLib: localeSk,
  },
  {
    code: 'sl',
    name: 'Slovenščina',
    displayNameEn: 'Slovenian',
    matLib: localeSl,
  },
  {
    code: 'sv',
    name: 'Svenska',
    displayNameEn: 'Swedish',
    matLib: localeSv,
  },
  {
    code: 'th',
    name: 'ไทย',
    displayNameEn: 'Thai',
    matLib: localeTh,
  },
  {
    code: 'tr',
    name: 'Türk',
    displayNameEn: 'Turkish',
    matLib: localeTr,
  },
  {
    code: 'vi',
    name: 'Việtnam',
    displayNameEn: 'Vietnamese',
    matLib: localeVi,
  },
  {
    code: 'zh-tw',
    name: '繁體中文',
    displayNameEn: 'Traditional Chinese',
    matLib: localeZh,
  },
  {
    code: 'zh-cn',
    name: '简体中文',
    displayNameEn: 'Simplified Chinese',
    matLib: localeZh,
  },
  {
    code: 'zh-hant-tw',
    name: '繁體中文（台灣）',
    displayNameEn: 'Traditional Chinese (Taiwan)',
    matLib: localeZh,
  },
];

export const getAvailableLanguages = (themeLanguageCodes?: string[]): AccredibleLanguage[] => {
  // Pick theme languages from available languages or use all available languages if none are specified by the theme
  return themeLanguageCodes
    ? AVAILABLE_LANGUAGES.filter((lang) => {
        return themeLanguageCodes.includes(lang.code);
      })
    : AVAILABLE_LANGUAGES;
};
